angular.module('app').controller('UserSettingsCtrl',
    ['$scope', '_', '$state', 'LanguageFactory', 'LocalStorageRepository', 'AprimaAnalytics',
        function ($scope, lodash, $state, LanguageFactory, LocalStorageRepository, AprimaAnalytics) {
            'use strict';

            $scope.mode = 'locked';
            $scope.usersettings = {
                username: LocalStorageRepository.getUserFullName(),
                clientId: LocalStorageRepository.getClientID()
            };
            $scope.usersettings.languages = [
                {
                    name: 'English',
                    id: 'en_US'
                },
                {
                    name: 'Spanish',
                    id: 'es_MX'
                }
            ];

            var currentLanguage = _($scope.usersettings.languages).filter({id: LanguageFactory.getLang().code}).pop();

            $scope.usersettings.language = currentLanguage ? currentLanguage.id : null;

            $scope.changeLanguage = function () {
                LanguageFactory.setLang($scope.usersettings.language);
                AprimaAnalytics.sendEvent('api', 'usersettings', 'change language', 0);
            };
        }]);
